import { Component, OnInit } from '@angular/core';
import { MyWorktimesService } from 'dm-src/app/modules/my-worktimes/my-worktimes.service';

@Component({
    selector: 'app-worktime-entry-editor',
    templateUrl: './worktime-entry-editor.component.html',
    styleUrls: ['./worktime-entry-editor.component.scss'],
})
export class WorktimeEntryEditorComponent implements OnInit {
    constructor(
        public myWorktimesService: MyWorktimesService) {}

    ngOnInit(): void {}

    public get currentSupplierRegionID(): string {
        return this.myWorktimesService.currentSupplierRegionID;
    }

    public setSupplierRegion(
        supplierRegionID: string) {
        this.myWorktimesService
            .setCurrentSupplierRegionID(supplierRegionID);
    }
}
